import { render } from "./ToxicologyPanelTestSelection.vue?vue&type=template&id=d81b4350&scoped=true"
import script from "./ToxicologyPanelTestSelection.vue?vue&type=script&lang=js"
export * from "./ToxicologyPanelTestSelection.vue?vue&type=script&lang=js"

import "./ToxicologyPanelTestSelection.vue?vue&type=style&index=0&id=d81b4350&lang=scss&scoped=true"
import "./ToxicologyPanelTestSelection.vue?vue&type=style&index=1&id=d81b4350&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81b4350"],['__file',"src/components/panels/testSelection/ToxicologyPanelTestSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d81b4350"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d81b4350', __exports__)) {
    console.log('reload')
    api.reload('d81b4350', __exports__)
  }
  
  module.hot.accept("./ToxicologyPanelTestSelection.vue?vue&type=template&id=d81b4350&scoped=true", () => {
    console.log('re-render')
    api.rerender('d81b4350', render)
  })

}


export default __exports__